module.exports = __webpack_public_path__ + "img/live-drop-14516583e293f481db908b26a9b1189a.af17e60a.png";